module.exports = __webpack_public_path__ + "images/Shopify-imageb4092d9258b2b94feb3aac399b69c4bd.png";